/*
	File: commenting.js
	Description: Append Comment Count Icons
*/

// import { profileHover } from './profile-hover';

/**Commenting**/

function appendCommentIcon() {
	if (typeof vfUuid != 'undefined' && typeof DFPTargetKeys != 'undefined' && typeof DFPTargetKeys.pageSegVars != 'undefined' && typeof DFPTargetKeys.pageSegVars.art != 'undefined') {
		var commentCountText = "";
		if (locale === 'de') {
			commentCountText = 'Kommentar';
		} else if (locale === 'fr') {
			commentCountText = "Commenter";
		} else if (locale === 'es') {
			commentCountText = "Comentario";
		} else if (locale === 'pt') {
			commentCountText = "Comente";
		} else {
			commentCountText = "Read Comments";
		}
		
		$(".crs-utils").prepend('<li class="comment-count hasComments" onclick="initComments();"><span class="viafoura-commentcount comment-number" data-vf-article-id="' + DFPTargetKeys.pageSegVars.art + '" data-vf-section-uuid="' + vfUuid + '">0</span><span class="comment-text comment-top">' + commentCountText + '</span></li>');
		$(".crs-footer_social").prepend('<span class="comment-count hasComments" onclick="initComments();"><span class="viafoura-commentcount comment-number" data-vf-article-id="' + DFPTargetKeys.pageSegVars.art + '" data-vf-section-uuid="' + vfUuid + '">0</span><span class="comment-text">' + commentCountText + '</span></span>');
	}
}

$(document).ready(function() {
	appendCommentIcon();
});